module.exports = "/_next/static/images/14-1e21f9d3ac4b62eb8f0934179a8a6ec3.png";